/** Why Sunny16 refused a request against a cart another request holds (the 409's `reason`). */
export enum CartOperationInProgressReason {
  Mutation = 'Mutation',
  Payment = 'Payment'
}
